import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { PassViewerPageComponent } from './pages/pass-viewer-page/pass-viewer-page.component';
import { PaymentFailurePageComponent } from './pages/payment-failure-page/payment-failure-page.component';
import { PaymentSuccessPageComponent } from './pages/payment-success-page/payment-success-page.component';
import { PrivacyPolicyPageComponent } from './pages/privacy-policy-page/privacy-policy-page.component';

const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'privacy-policy',
        component: PrivacyPolicyPageComponent
      },
      {
        path: 'payment',
        children: [
          {
            path: 'success',
            component: PaymentSuccessPageComponent
          },
          {
            path: 'failure',
            component: PaymentFailurePageComponent
          }
        ]
      },
      {
        path: ':uid',
        component: PassViewerPageComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
